import {
  type EnergyAnalysisFiles,
  type EnergyAnalysisFileSection,
  type FileWithInfo,
  type FileWithInfoLocal,
  type SingleBuildingFormState,
} from "../model/types";

export function cloneFormDataForSubmit(formData: SingleBuildingFormState): SingleBuildingFormState {
  const files = formData.files;
  const clonedFiles: EnergyAnalysisFiles = files
    ? (Object.fromEntries(
        Object.entries(files).map(([section, list]) => [section, (list ?? []).map((f) => ({ ...f }))])
      ) as EnergyAnalysisFiles)
    : {};

  return {
    ...formData,
    files: clonedFiles,
    images: (formData.images ?? []).map((img) => ({ ...img })),
  };
}

export function matchesFileWithInfo(a: FileWithInfo, b: FileWithInfo): boolean {
  return a.id === b.id;
}

export function withFileSectionUrl(
  form: SingleBuildingFormState,
  section: EnergyAnalysisFileSection,
  target: FileWithInfoLocal,
  url: string
): SingleBuildingFormState {
  const prevFiles = form.files ?? {};
  const sectionList = prevFiles[section] ?? [];
  const nextSection = sectionList.map((f) => (matchesFileWithInfo(f, target) ? { ...f, cloudPath: url } : f));
  return {
    ...form,
    files: { ...prevFiles, [section]: nextSection },
  };
}

export function withImageUrl(
  form: SingleBuildingFormState,
  target: FileWithInfoLocal,
  url: string
): SingleBuildingFormState {
  const images = (form.images ?? []).map((img) =>
    matchesFileWithInfo(img, target) ? { ...img, cloudPath: url } : img
  );
  return { ...form, images };
}
